import styled from 'styled-components';
import { Button, IconButton, Typography, SwipeableDrawer, SwipeableDrawerProps } from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import MuiAvatar from '@mui/material/Avatar';
import MuiToolbar from '@mui/material/Toolbar';
import { ComponentType } from 'react';
import { COLORS } from 'assets/colors';

export const MenuButton = styled(IconButton).attrs({
  edge: 'start',
  color: 'primary',
  'aria-label': 'menu',
})`
  @media (min-width: 1025px) {
    display: none;
  }
`;

export const DesktopIconButton = styled(IconButton)`
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const MobileIconButton = styled(IconButton)`
  @media (min-width: 481px) {
    display: none;
  }
`;

export const Title = styled(Typography)`
  font-size: 12px;
  font-weight: 600;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (min-width: 481px) {
    font-size: 16px;
  }
  @media (min-width: 1025px) {
    font-size: 20px;
  }
`;

export const ProfileButton = styled(Button).attrs({
  color: 'primary',
})`
  padding-left: 16px;
  padding-right: 16px;

  & .MuiButton-label {
    font-size: 16px;
    font-weight: 600;
  }

  @media (max-width: 480px) {
    display: none;
  }
`;

export const AppBar = styled(MuiAppBar).attrs({
  position: 'fixed',
  color: 'default',
})`
  background-color: #fff;
  box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 0px 2px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
`;

export const Toolbar = styled(MuiToolbar)`
  min-height: 64px;

  @media (max-width: 480px) {
    min-height: 48px;
  }
`;

export const Grow = styled.div`
  flex-grow: 1;
`;

export const Avatar = styled(MuiAvatar)`
  height: 30px;
  width: 30px;
`;

export const LogoAvatar = styled(MuiAvatar)`
  height: 48px;
  width: 48px;
  margin-right: 8px;

  @media (max-width: 480px) {
    height: 32px;
    width: 32px;
    margin-right: 8px;
  }
`;

export const Drawer = styled(SwipeableDrawer)`
  @media (min-width: 1025px) {
    display: none;
  }
` as ComponentType<SwipeableDrawerProps>;

export const DrawerBody = styled.div`
  width: 250px;

  .MuiList-root {
    .MuiListItem-root {
      color: ${COLORS.blue};
      svg {
        stroke: ${COLORS.blue};
      }
    }

    span.MuiTypography-root {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0.4px;
    }

    a {
      text-decoration: none;
    }

    a.active {
      color: ${COLORS.lightBlue};

      svg {
        stroke: ${COLORS.lightBlue};
      }
    }
  }
`;

export const ProfileWrap = styled.div`
  background-color: rgba(0, 0, 0, 0.095);
  padding: 8px 4px 8px 8px;
  display: flex;
  align-items: flex-end;

  .MuiTypography-root {
    font-size: 14px;
    font-weight: 800;
    color: ${COLORS.blue};
  }

  a {
    font-size: 12px;
    font-weight: 700;
    text-decoration: none;
    letter-spacing: 0.4px;
    line-height: 1;
    color: ${COLORS.lightBlue};
  }
`;
